import React from 'react'
import { Form } from '../../../lib/ui/form'
import { Button } from '~/components/_atoms/index'
import { InputField, TextField } from '../../shared/FormFields'
import { Loading } from '~/lib/ui/loading'
import { useCoachResourceForm } from './useCoachResourceForm'

const NewCoachResourceForm = ({
  showCreateResourceForm,
  onCancel,
  onResourceCreated,
  setIsOpen,
}) => {
  const { form, onSubmit } = useCoachResourceForm({
    showCreateResourceForm,
    onResourceCreated,
    setIsOpen,
  })

  const { watch } = form

  const name = watch('name')
  const description = watch('description')
  const length = watch('length')
  const url = watch('url')
  const canSubmit = name && description && length && url

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
        <InputField
          name="name"
          control={form.control}
          placeholder="Enter the resource name"
          className="w-full md:w-1/2"
          label="Name (required)"
        />
        <TextField
          name="description"
          control={form.control}
          placeholder="Enter a brief description of the resource"
          className="w-full"
          label="Description (required)"
          rows={4}
        />
        <InputField
          name="url"
          control={form.control}
          placeholder="e.g. https://www.example.com"
          className="w-full md:w-1/2"
          label="URL (required)"
        />
        <InputField
          name="length"
          type="number"
          control={form.control}
          placeholder="e.g. 30"
          className="w-full md:w-1/4"
          label="Estimated Minutes to Complete (required)"
        />
        <div className="!mt-12 flex gap-2">
          <Button
            disabled={form.formState.isSubmitting || !canSubmit}
            onClick={() => form.handleSubmit((data) => onSubmit(data, false))()}
          >
            {form.formState.isSubmitting ? <Loading /> : 'Create Resource'}
          </Button>
          <Button
            disabled={form.formState.isSubmitting || !canSubmit}
            onClick={() => form.handleSubmit((data) => onSubmit(data, true))()}
          >
            {form.formState.isSubmitting ? (
              <Loading />
            ) : (
              'Create Resource & Add to Action Plan'
            )}
          </Button>
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </form>
    </Form>
  )
}

export default NewCoachResourceForm
